import { ExperimentFlagData, IExperimentContext } from '@root/featureflags/types';
import { useFlagsmithLoading } from 'flagsmith/react';
import { createContext, useEffect, useState } from 'react';

import { isFlagError } from './utils';

const DEFAULT_EXPERIMENT_CONTEXT: IExperimentContext<any> = {
  ready: false,
  flags: {},
  setFlags: () => {}
};

export const ExperimentContext = createContext(DEFAULT_EXPERIMENT_CONTEXT);

const useExperimentState = <T,>(): IExperimentContext<T> => {
  const [ready, setReady] = useState(false);
  const [flags, setFlags] = useState<Record<string, ExperimentFlagData<T>>>({});
  const flagsmithLoading = useFlagsmithLoading();
  const { source: flagSource, error: flagsmithError } = flagsmithLoading ?? {};

  useEffect(() => {
    const flagSourceIsFresh = flagSource === 'CACHE' || flagSource === 'SERVER';

    if (isFlagError(flagsmithError)) {
      // If Flagsmith is unreachable, we say the experiment is ready, in which case it will fallback to the default value (off)
      setReady(true);
    } else if (ready !== flagSourceIsFresh) {
      setReady(flagSourceIsFresh);
    }
  }, [flagSource, flagsmithError]);
  return {
    ready,
    flags,
    setFlags
  };
};

export const ExperimentProvider = ({ children }: { children: React.ReactNode }) => {
  const state = useExperimentState();

  return <ExperimentContext.Provider value={state}>{children}</ExperimentContext.Provider>;
};
